import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

//引入页面组件
import Index from "@/views/index.vue";
import About from "@/views/about.vue";
import Rank from "@/views/rank.vue";
import Matrix from "@/views/matrix.vue";
import Service from "@/views/service.vue";
import Famous from "@/views/famous.vue";
import Voice from "@/views/voice.vue";
import Expert from "@/views/expert.vue";
import Policy from "@/views/policy.vue";
import Article from "@/views/article.vue";
import AuthRedirect from "@/views/authRedirect.vue";
import SameIndustry from "@/views/sameIndustry.vue";
import Career from "@/views/career.vue";
import Industry from "@/views/industry.vue";
import Thesis from "@/views/thesis.vue";
import major_analyze from "@/views/major_analyze.vue";
import industry_data from "@/views/industry_data.vue";
import industry_career from "@/views/industry_career.vue";
import career_job from "@/views/career_job.vue";
import common_job from "@/views/common_job.vue";
import group from "@/views/group.vue";
import target_job from "@/views/target_job.vue";
import typical_task from "@/views/typical_task.vue";
import job_ability from "@/views/job_ability.vue";
import job_course from "@/views/job_course.vue";
import data_source from "@/views/match/data_source.vue";
import trend from "@/views/match/trend.vue";
import factor from "@/views/match/factor.vue";
import expand from "@/views/match/expand.vue";
import talent from "@/views/match/talent.vue";
import focus from "@/views/match/focus.vue";
import calcu from "@/views/match/calcu.vue";
import compare from "@/views/match/compare";
import match_report from "@/views/match/match_report";
import match_index from "@/views/match/index";
import policy_list from "@/views/policy_list";
import job_report from "@/views/job_report";
import dvn_index from "@/views/deviation/dvn_index";
import dvn_gdp from "@/views/deviation/dvn_gdp";
import dvn_job from "@/views/deviation/dvn_job";
import dvn_enroll from "@/views/deviation/dvn_enroll";
import dvn_result from "@/views/deviation/dvn_result";
import mis_index from "@/views/mismatch/mis_index";
import mis_gdp from "@/views/mismatch/mis_gdp";
import mis_job from "@/views/mismatch/mis_job";
import mis_edu from "@/views/mismatch/mis_edu";
import mis_other from "@/views/mismatch/mis_other";
import mis_rate from "@/views/mismatch/mis_rate";
import fit_index from "@/views/fit/fit_index";
import fit_enroll from "@/views/fit/fit_enroll";
import fit_config from "@/views/fit/fit_config";
import fit_industry from "@/views/fit/fit_industry";
import fit_enroll_calcu from "@/views/fit/fit_enroll_calcu";
import fit_industry_calcu from "@/views/fit/fit_industry_calcu";
import industry_index from "@/views/report_industry/industry_index";
import industry_index_s from "@/views/report_industry/industry_index_s";
import industry_report from "@/views/report_industry/industry_report";
import ability_index from "@/views/report_ability/ability_index";
import ability_index_s from "@/views/report_ability/ability_index_s";
import ability_report from "@/views/report_ability/ability_report";
import talent_index from "@/views/report_talent/talent_index";
import talent_index_s from "@/views/report_talent/talent_index_s";
import talent_report from "@/views/report_talent/talent_report";
import course_index from "@/views/report_course/course_index";
import course_index_s from "@/views/report_course/course_index_s";
import course_report from "@/views/report_course/course_report";
import training_index from "@/views/report_training/training_index";
import target_index_s from "@/views/report_target/target_index_s";
import target_report from "@/views/report_target/target_report";

//配置路由与页面组件的关系
const routes = [{
		path: "/",
		component: Index
	},
	{
		path: "/about",
		component: About
	},
	{
		path: "/rank",
		component: Rank
	},
	{
		path: "/matrix",
		component: Matrix
	},
	{
		path: "/service",
		component: Service
	},
	{
		path: "/famous",
		component: Famous
	},
	{
		path: "/voice",
		component: Voice
	},
	{
		path: "/voice/expert/:id",
		component: Expert
	},
	{
		path: "/policy",
		component: Policy
	},
	{
		path: "/article",
		component: Article
	},
	{
		path: "/authRedirect",
		component: AuthRedirect
	},
	{
		path: "/sameIndustry",
		component: SameIndustry
	},
	{
		path: "/career",
		component: Career
	},
	{
		path: "/industry",
		component: Industry
	},
	{
		path: "/thesis",
		component: Thesis
	},
	{
		path: "/major_analyze",
		component: major_analyze
	},
	{
		path: "/industry_data",
		component: industry_data
	},
	{
		path: "/industry_career",
		component: industry_career
	},
	{
		path: "/career_job",
		component: career_job
	},
	{
		path: "/common_job",
		component: common_job
	},
	{
		path: "/group",
		component: group
	},
	{
		path: "/target_job",
		component: target_job
	},
	{
		path: "/typical_task",
		component: typical_task
	},
	{
		path: "/job_ability",
		component: job_ability
	},
	{
		path: "/job_course",
		component: job_course
	},
	{
		path: "/data_source",
		component: data_source
	},
	{
		path: "/trend",
		component: trend
	},
	{
		path: "/factor",
		component: factor
	},
	{
		path: "/expand",
		component: expand
	},
	{
		path: "/talent",
		component: talent
	},
	{
		path: "/focus",
		component: focus
	},
	{
		path: "/calcu",
		component: calcu
	},
	{
		path: "/compare",
		component: compare
	},
	{
		path: "/policy_list",
		component: policy_list
	},
	{
		path: "/job_report",
		component: job_report
	},
	{
		path: "/match_index",
		component: match_index
	},
	{
		path: "/dvn_index",
		component: dvn_index
	},
	{
		path: "/dvn_gdp",
		component: dvn_gdp
	},
	{
		path: "/dvn_job",
		component: dvn_job
	},
	{
		path: "/dvn_enroll",
		component: dvn_enroll
	},
	{
		path: "/dvn_result",
		component: dvn_result
	},
	{
		path: "/mis_index",
		component: mis_index
	},
	{
		path: "/mis_gdp",
		component: mis_gdp
	},
	{
		path: "/mis_job",
		component: mis_job
	},
	{
		path: "/mis_edu",
		component: mis_edu
	},
	{
		path: "/mis_other",
		component: mis_other
	},
	{
		path: "/mis_rate",
		component: mis_rate
	},
	{
		path: "/fit_index",
		component: fit_index
	},
	{
		path: "/fit_enroll",
		component: fit_enroll
	},
	{
		path: "/fit_config",
		component: fit_config
	},
	{
		path: "/fit_industry",
		component: fit_industry
	},
	{
		path: "/industry_index",
		component: industry_index
	},
	{
		path: "/industry_index_s",
		component: industry_index_s
	},
	{
		path: "/industry_report",
		component: industry_report
	},
	{
		path: "/talent_index",
		component: talent_index
	},
	{
		path: "/talent_index_s",
		component: talent_index_s
	},
	{
		path: "/talent_report",
		component: talent_report
	},
	{
		path: "/ability_index",
		component: ability_index
	},
	{
		path: "/ability_index_s",
		component: ability_index_s
	},
	{
		path: "/ability_report",
		component: ability_report
	},
	{
		path: "/course_index",
		component: course_index
	},
	{
		path: "/course_index_s",
		component: course_index_s
	},
	{
		path: "/training_index",
		component: training_index
	},
	{
		path: "/fit_enroll_calcu",
		component: fit_enroll_calcu
	},
	{
		path: "/fit_industry_calcu",
		component: fit_industry_calcu
	},
	{
		path: "/match_report",
		component: match_report
	},
	{
		path: "/course_report",
		component: course_report
	},
	{
		path: "/target_index_s",
		component: target_index_s
	},
	{
		path: "/target_report",
		component: target_report
	}

];

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push
let routerReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
	return routerReplace.call(this, location).catch(err => err)
}

export default new Router({
	mode: 'history', // 去掉url中的#
	scrollBehavior: () => ({
		y: 0
	}),
	routes: routes
})